module.exports = __webpack_public_path__ + "assets/icons/ic_help-f7ae.svg";